// extracted by mini-css-extract-plugin
module.exports = {"asset-details-rule":"asset-details-rule__bpEDS"};